import { Action } from '@ngrx/store';
import { AuthActionType } from 'app/core/authentication/state/actions/auth-action-type.enum';

import { Username } from 'app/core/authentication/models';

export class PasswordReset implements Action {
  public readonly type: AuthActionType = AuthActionType.PasswordReset;
  public readonly payload: Username;

  constructor({ username = undefined }: Username) {
    this.payload = new Username(username);
  }
}

export class PasswordResetSent implements Action {
  public readonly type: AuthActionType = AuthActionType.PasswordResetSent;

  constructor(public readonly payload: string) { }
}

export class PasswordResetFailed implements Action {
  public readonly type: AuthActionType = AuthActionType.PasswordResetFailed;

  constructor(public readonly payload: string) { }
}
